<template>
  <div :class="$style.container">
    <div :class="$style.header">
      <h3 :class="$style.title">国家</h3>
      <search-field v-model="keyword" class="ml-auto" placeholder="请输入国家名称" />
    </div>

    <div ref="bodyRef" :class="$style.body">
      <el-scrollbar :wrap-class="$style.scrollbarWrap">
        <index-block v-for="continent in continents" :key="continent.id" :class="$style.block" headerClass="px-3" :title="continent.name">
          <ul :class="$style.grid">
            <li v-for="(country, index) in continent.country" :key="index" :class="$style.gridItem" :title="country.name">
              <div :class="$style.country" @click="$emit('item-click', country)">
                {{country.name}}</div>
            </li>
          </ul>
        </index-block>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import {
	defineComponent,
	ref,
	useStore,
	computed,
	watchEffect
} from "@nuxtjs/composition-api";
import { useElementSize } from "@vueuse/core";
import { groupBy, isEmpty } from "lodash";
import useJsSearch from "./composables/useJsSearch";
import IndexBlock from "./index-block.vue";
import SearchField from "./search-field";

export default defineComponent({
	name: "IndexCountrySelect",
	components: {
		SearchField,
		IndexBlock
	},
	setup() {
		const keyword = ref("");
		const bodyRef = ref();
		const { height: bodyHeight } = useElementSize(bodyRef);
		const store = useStore();

		const { addIndex, setComments, search } = useJsSearch();

		watchEffect(() => {
			if (!isEmpty(store.state.cruiseMap.filterData.continent)) {
				const continents = store.state.cruiseMap.filterData.continent.map(
					(item) =>
						item.country.map((country) => ({
							...country,
							continent_key: `${item.id}__${item.name}`
						}))
				);
				setComments(continents.flat());
			}
		});

		addIndex("name");

		const continents = computed(() => {
			let result = search(keyword.value);
			result = groupBy(result, "continent_key");
			return Object.entries(result).map(([key, item]) => {
				const [id, name] = key.split("__");
				return {
					id,
					name,
					country: item
				};
			});
		});

		return {
			continents,
			bodyRef,
			bodyHeight,
			keyword
		};
	}
});
</script>
<style lang="scss" module>
.container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  max-height: 25rem;
}
.header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.body {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  overflow: hidden;
}
.title {
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.block {
  margin-top: 1rem;
}
.blockTitle {
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.scrollbarWrap {
  max-height: 23rem;
}
.grid {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.gridItem {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  width: 25%;
}
.country:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}
.country {
  border-radius: 0.125rem;
  cursor: pointer;
  height: 1.75rem;
  font-size: 0.75rem;
  line-height: 1rem;
  line-height: 1.75rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  text-align: center;
  width: 4.5rem;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>